import { render, staticRenderFns } from "./CompanionGuideCard.vue?vue&type=template&id=23c68a38&scoped=true&lang=pug&"
import script from "./CompanionGuideCard.vue?vue&type=script&lang=js&"
export * from "./CompanionGuideCard.vue?vue&type=script&lang=js&"
import style0 from "./CompanionGuideCard.vue?vue&type=style&index=0&id=23c68a38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c68a38",
  null
  
)

export default component.exports